// extracted by mini-css-extract-plugin
export var active = "_l-8";
export var addWidgetButton = "_l-9";
export var backButton = "_l-1";
export var pageContainer = "_l-2";
export var settingsContent = "_l-0";
export var sideNavContainer = "_l-6";
export var sideNavLink = "_l-7";
export var widgetContainer = "_l-5";
export var widgetSubsectionItem = "_l-3";
export var widgetSubsectionItemContent = "_l-4";